import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c8c03d6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "auth-infos-container"
};
const _hoisted_2 = {
  class: "user-list-panel"
};
const _hoisted_3 = {
  class: "user-list-panel-header"
};
const _hoisted_4 = {
  class: "user-list-panel-content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "permission-panel"
};
const _hoisted_7 = {
  class: "panel-header"
};
const _hoisted_8 = {
  key: 0,
  class: "no-authority"
};
const _hoisted_9 = {
  class: "panel-table"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "pagination-container"
};
import { useAuthinfo } from "./hook/useAuthinfo";
export default {
  __name: 'authInfos',
  setup(__props) {
    const {
      permissionGroups,
      currentCheckedKeys,
      currentCheckMenuAuthorityList,
      currentCheckMenuPermissionId,
      currentPersimmonUserList,
      tableLoading,
      expandedKeys,
      currentType,
      menuItems,
      roleColumns,
      userColumns,
      handleMenuClick,
      handleNodeClick,
      handleSearchMenu,
      handleAuthorityClick,
      handleUserSearchRoleTable,
      handleRoleSearchRoleTable,
      handleCancelAuth,
      searchValue,
      userSearchValue,
      roleSearchValue,
      tableKeyRandom,
      page,
      handlePageChange,
      handlePageSizeChange,
      paginationData
    } = useAuthinfo();
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_tree = _resolveComponent("a-tree");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_input, {
        value: _unref(searchValue),
        "onUpdate:value": _cache[0] || (_cache[0] = $event => _isRef(searchValue) ? searchValue.value = $event : null),
        placeholder: "请输入菜单名称",
        style: {
          "width": "95%"
        },
        onPressEnter: _unref(handleSearchMenu)
      }, null, 8, ["value", "onPressEnter"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_tree, {
        selectedKeys: _unref(currentCheckedKeys),
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => _isRef(currentCheckedKeys) ? currentCheckedKeys.value = $event : null),
        expandedKeys: _unref(expandedKeys),
        "onUpdate:expandedKeys": _cache[2] || (_cache[2] = $event => _isRef(expandedKeys) ? expandedKeys.value = $event : null),
        "tree-data": _unref(permissionGroups),
        fieldNames: {
          title: 'name',
          key: 'id',
          children: 'items'
        },
        blockNode: true,
        selectable: false
      }, {
        title: _withCtx(item => [_createElementVNode("span", {
          class: _normalizeClass({
            'node-selected': _unref(currentCheckedKeys).includes(item.id)
          }),
          onClick: $event => _unref(handleNodeClick)($event, item)
        }, _toDisplayString(item.name), 11, _hoisted_5)]),
        _: 1
      }, 8, ["selectedKeys", "expandedKeys", "tree-data"])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_unref(currentCheckMenuAuthorityList).length === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "暂无权限")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentCheckMenuAuthorityList), (item, index) => {
        return _openBlock(), _createBlock(_component_a_tag, {
          style: {
            "cursor": "pointer"
          },
          color: _unref(currentCheckMenuPermissionId) === item.permissionId ? 'blue' : 'default',
          key: index,
          onClick: $event => _unref(handleAuthorityClick)(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["color", "onClick"]);
      }), 128))]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_menu, {
        selectedKeys: _unref(currentType),
        "onUpdate:selectedKeys": _cache[3] || (_cache[3] = $event => _isRef(currentType) ? currentType.value = $event : null),
        mode: "horizontal",
        items: _unref(menuItems),
        onClick: _unref(handleMenuClick)
      }, null, 8, ["selectedKeys", "items", "onClick"]), _unref(currentType)[0] === 'user' ? (_openBlock(), _createBlock(_component_a_input, {
        key: 0,
        value: _unref(userSearchValue),
        "onUpdate:value": _cache[4] || (_cache[4] = $event => _isRef(userSearchValue) ? userSearchValue.value = $event : null),
        placeholder: "请输入账号/姓名查询",
        onPressEnter: _unref(handleUserSearchRoleTable),
        style: {
          "width": "20%",
          "margin-top": "12px",
          "margin-bottom": "12px"
        }
      }, null, 8, ["value", "onPressEnter"])) : (_openBlock(), _createBlock(_component_a_input, {
        key: 1,
        value: _unref(roleSearchValue),
        "onUpdate:value": _cache[5] || (_cache[5] = $event => _isRef(roleSearchValue) ? roleSearchValue.value = $event : null),
        placeholder: "请输入角色名称查询",
        onPressEnter: _unref(handleRoleSearchRoleTable),
        style: {
          "width": "20%",
          "margin-top": "12px",
          "margin-bottom": "12px"
        }
      }, null, 8, ["value", "onPressEnter"])), (_openBlock(), _createBlock(_component_a_table, {
        pagination: false,
        bordered: "",
        loading: _unref(tableLoading),
        key: _unref(tableKeyRandom),
        columns: _unref(currentType)[0] === 'role' ? _unref(roleColumns) : _unref(userColumns),
        "data-source": _unref(paginationData),
        scroll: {
          y: 520
        },
        rowClassName: () => 'table-row-left'
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'operation' ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: $event => _unref(handleCancelAuth)(record),
          style: {
            "cursor": "pointer",
            "color": "#5c48f7"
          }
        }, _toDisplayString(_unref(currentType)[0] === "role" ? "取消角色授权" : "取消用户授权"), 9, _hoisted_10)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["loading", "columns", "data-source", "rowClassName"])), _createElementVNode("div", _hoisted_11, [_createVNode(_component_a_pagination, {
        current: _unref(page).pageIndex,
        "onUpdate:current": _cache[6] || (_cache[6] = $event => _unref(page).pageIndex = $event),
        pageSize: _unref(page).pageSize,
        "onUpdate:pageSize": _cache[7] || (_cache[7] = $event => _unref(page).pageSize = $event),
        "show-size-changer": "",
        pageSizeOptions: [10, 30, 50],
        "show-total": total => `共 ${total} 条`,
        total: _unref(currentType)[0] === 'role' ? _unref(currentPersimmonUserList).roleInfos.length : _unref(currentPersimmonUserList).userInfos.length,
        onChange: _unref(handlePageChange),
        onShowSizeChange: _unref(handlePageSizeChange)
      }, null, 8, ["current", "pageSize", "show-total", "total", "onChange", "onShowSizeChange"])])])])]);
    };
  }
};